import { ScreenId } from "@versatile-credit-apply/omni-apply-client"
import type { FlowOutcome } from "@versatile-credit-apply/omni-apply-client"
import { useCurrentProviderKey } from "@versatile-credit-apply/sdk"
import { useRouter } from "vue-router"

export const useExitFlow = () => {
  const router = useRouter()
  const providerKey = useCurrentProviderKey()

  return (outcome: FlowOutcome, screenId?: ScreenId) =>
    router.replace({
      path: "/finish",
      query: {
        outcome: outcome,
        providerKey: providerKey.value,
        screenId: screenId,
      },
    })
}
